// @flow
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { getOS } from '../../utils';
import AvaDesktopDownloadImage from '../../../assets/images/avaCaptionsDesktopDownload.png';

const styles = theme => ({
  title: {
    color: theme.palette.ava.blue,
    fontWeight: 600,
    fontSize: 30,
    marginTop: theme.spacing(3),
  },
  illustration: {
    maxWidth: '100%',
    marginTop: theme.spacing(6),
  },
  getAppButton: {
    textTransform: 'none',
    color: 'white',
    borderRadius: 24,
    backgroundColor: theme.palette.ava.blue,
    fontSize: 18,
    fontWeight: 600,
    borderLeftStyle: 'solid !important',
    borderColor: 'lightgray !important',
    height: 48,
    marginBottom: 12,
    '&:hover': {
      backgroundColor: theme.palette.ava.blue,
      color: 'white',
    },
    padding: '8px 20px',
    maxWidth: 380,
    width: '100%',
    whiteSpace: 'nowrap',
    margin: 'auto',
    display: 'block',
  },
  continueButton: {
    textDecoration: 'underline',
    fontSize: 15,
    margin: 'auto',
    display: 'block',
    marginTop: theme.spacing(3),
  },
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(8),
  },
}))(MuiDialogContent);

const DesktopAppCaptionsModal = ({
  t,
  onClose,
  classes,
}: {
  t: Function,
  onClose: Function,
  classes: Object,
}) => {
  const OS = getOS();
  return (
    <div>
      <Dialog aria-labelledby="customized-dialog-title" open onClose={onClose}>
        <DialogContent>
          <Typography align="center" className={classes.title}>
            <span>{t('conversation.captionsModal.1clickCaptions')}</span>
          </Typography>
          <img
            className={classes.illustration}
            src={AvaDesktopDownloadImage}
            alt="ava desktop download"
          />
          <Button
            onClick={() => {
              window.open('https://www.ava.me/captions');
            }}
            className={classes.getAppButton}
          >
            {t('conversation.captionsModal.getAva', { OS })}
          </Button>
          <Button onClick={onClose} className={classes.continueButton}>
            {t('conversation.captionsModal.continue')}
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(DesktopAppCaptionsModal);
